import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'switch',
    props: {
        modelValue: { type: [null, Boolean, Number, String], default: null },
        readonly: { type: Boolean, default: false },
        trueValue: { type: [null, Boolean, Number, String], default: true },
        falseValue: { type: [null, Boolean, Number, String], default: false },
        customClass: { default: '' },
        disabled: { type: Boolean, default: false },
        size: { default: 'small' }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function toggle() {
            if (props.readonly || props.disabled) {
                return;
            }
            if (props.modelValue === props.trueValue) {
                emit('update:modelValue', props.falseValue);
            }
            else {
                emit('update:modelValue', props.trueValue);
            }
        }
        const sizeClass = computed(() => {
            return `switch-v2--${props.size}`;
        });
        const switchClasses = computed(() => {
            return [
                'switch-v2',
                props.customClass ? props.customClass : '',
                sizeClass.value
            ].join(' ');
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                class: _normalizeClass(switchClasses.value)
            }, [
                _createElementVNode("input", {
                    class: _normalizeClass([{ 'switch-checked-v2': props.modelValue === props.trueValue }]),
                    disabled: props.disabled,
                    onClick: toggle,
                    type: "checkbox"
                }, null, 10, _hoisted_1),
                _createElementVNode("span", null, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 2));
        };
    }
});
